/**
 * xxx機能定義ファイル
 * 概要
 * 更新履歴
 */
/* eslint-disable @typescript-eslint/camelcase */

/** 登録ガイドメッセージ */
export const authorityValidMessage = 'この内容でよろしければ「登録する」を押してください';
export const authorityInvalidMessage = '登録権限を持たないユーザです';
export const registerFinishText = '登録が完了いたしました';

// 振替、仕入非表示時にトランなどに情報がない例外項目リスト
export const ExceptionHeaderItem = [
  'No',
  'copyButton',
  'deleteButton',
  'selectButtonIndex',
  // 'sale_price',
  'standard_unit_price',
  'item',
  'model_number',
  'classification_id',
  'type_id',
  'item_code'
];

// 部品一覧のカラム
export const PartsListHeaders = [
  { text: 'No', value: 'No', width: '30' },
  { text: '品名', value: 'item', width: '100' },
  { text: '型番', value: 'model_number', width: '100' },
  { text: '標準単価', value: 'standard_unit_price', width: '100' },
  { text: '振替単価(参照用)', value: 'reference_transfer_unit_price', width: '148' },
  { text: '振替単価', value: 'transfer_unit_price', width: '130' },
  { text: '数量', value: 'quantity', width: '80' },
  { text: '販売金額', value: 'sale_price', width: '120' },
  { text: '振替金額', value: 'transfer_amount_price', width: '120' },
  { text: '営業利益', value: 'operating_income', width: '98' },
  { text: '利益率', value: 'profit_rate', width: '86' },
  { text: '備考', value: 'remarks', width: '74', sortable: false },
  { text: '区分', value: 'classification_id', width: '80' },
  { text: '種別', value: 'type_id', width: '100' },
  { text: '品名コード', value: 'item_code', width: '100' },
  { text: '単価下限', value: 'unit_lower_limit', width: '120' },
  { text: '単価上限', value: 'unit_upper_limit', width: '120' },
  { text: '数量下限', value: 'quantity_lower_limit', width: '40' },
  { text: '数量上限', value: 'quantity_upper_limit', width: '40' },
  { text: '金額変更可', value: 'edit_price_flag', width: '80' },
  { text: '編集可', value: 'edit_material_flag', width: '80' }
];

export const MaterialTemplateListDefine = {
  display: 'materialtemplateList',
  editPage: 'MaterialTemplateEdit',
  searchFieldCols: '10% 10% 10% 10% 10% 10%',
  tableColumns: [
    { text: '個別', value: 'i_id', sortable: false, width: 80 },
    { text: '社員コード', value: 'id', width: 110 },
    { text: '社員名', value: 'name', width: 130 },
    { text: 'メールアドレス', value: 'email', width: 200 },
    { text: '所属会社名', value: 'company_id', width: 200 },
    { text: '操作権限名', value: 'operation_authority_name', width: 200 }
  ],
  tableSelect: [
    {
      name: 'new_u_id',
      alwaysDisplayed: true,
      options: [] as { [k: string]: string }[],
      placeholder: '変更なし',
      rules: 'is_uniq_account'
    }
  ],
  tableCheck: [
    { name: 'is_mtempbase_active', alwaysDisplayed: true, value: false, isDisabled: true }
  ],
  message: {
    dataTableText: '検索を行ってください',
    pageDescription: '構成表テンプレート情報の一括更新を行います。',
    overwriteWarn: 'アカウントの切替が発生します',
    duplicateWarn: '重複した環境ユーザを登録しようとしています',
    notSearch: '社員検索してください',
    notUpdateRow: '更新対象レコードがありません',
    actionConf:
      '選択されたユーザとアカウントの紐づけを行い、システムにログイン可能な状態にします。',
    updateFail: '更新に失敗しました。',
    updateSuccess: '更新が成功しました。'
  },
  action: 'update',
  dialog: {
    processDialogTitle: '処理実行',
    errDialogTitle: 'エラー'
  },
  inputColumns: {
    activeCheckBox: 'is_mtempbase_active',
    activeCheckBoxDisable: 'is_mtempbase_active-disable',
    messageColumn: 'column_message',
    modifyUid: 'new_u_id'
  }
};
export const MaterialTemplateMasterDeleteStatusExcludeSearch = {
  id: 'Status', // Hexabase画面で入力したIDを指定
  search_value: ['mtempbase_deleted'],
  exact_match: true, // 完全一致で検索
  not_match: true // search_valueに指定した値でないItemを検索(NOT条件)
};

/** 検索パネルのGrid1区間の横幅（%） */
export const SearchPanelColumnWidth = 5;
export const registerFinishAction = [
  {
    id: 1,
    color: 'primary',
    type: 'routing',
    name: 'toEdit',
    value: '詳細画面へ',
    route: '/materialtemplate/edit/:id'
  }
];
export const editFinishText = 'xxx情報を編集しました';
export const editFinishAction = [
  {
    id: 1,
    color: 'primary',
    type: 'reload',
    name: 'reload',
    value: '閉じる'
  }
];
// 自動採番APIの格納フィールドIDと採番フィールドID
// eslint-disable-next-line @typescript-eslint/no-namespace
namespace autoNumber {
  export const Define: { [k: string]: { [k: string]: string } } = {
    appNumber: {
      displayId: 'materialtemplate_application_no',
      autoFieldId: '_autonum_materialtemplate_application_no',
      linkDsFieldId: 'materialtemplate_application_no'
    },
    customerNumber: {
      displayId: 'materialtemplate_no',
      autoFieldId: '_autonum_materialtemplate_no',
      linkDsFieldId: 'materialtemplate_no'
    }
  };
}
export const AutoNumberDefine = autoNumber.Define;

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace MaterialtemplateListDisplayInputFormatItem {
  // 一覧表示内の入力項目内で使用するフォーマット設定
  export const Quantity = {
    name: 'quantity',
    type: 'number',
    rules: ['between_quantity', 'max_limit_quantity', 'min_limit_quantity'],
    min: 0,
    max: 9999999999,
    hideDetails: 'auto'
  };
  export const QuantityLowerLimit = {
    name: 'quantity_lower_limit',
    type: 'number',
    rules: ['between_quantity'],
    min: 0,
    max: 9999999999,
    hideDetails: 'auto'
  };
  export const QuantityUpperLimit = {
    name: 'quantity_upper_limit',
    type: 'number',
    rules: ['between_quantity'],
    min: 0,
    max: 9999999999,
    hideDetails: 'auto'
  };
  export const SalePrice = {
    name: 'sale_price',
    type: 'number',
    rules: ['between_price'],
    hideDetails: 'auto',
    min: -9999999999,
    max: 9999999999
  };
  export const InputItems = {
    name: 'item',
    type: 'text',
    inputCheckFlag: true,
    inputCheckName: 'input_flag',
    hideDetails: 'auto',
    rules: []
  };
  export const ProductName = {
    name: 'item',
    type: 'text',
    inputCheckFlag: true,
    inputCheckName: 'input_flag',
    hideDetails: 'auto',
    rules: []
  };
  export const UnitPrice = {
    name: 'unit_price',
    type: 'number',
    rules: ['between_price'],
    hideDetails: 'auto',
    min: -9999999999,
    max: 9999999999
  };
  export const PurchaseUnitPrice = {
    name: 'purchase_unit_price',
    type: 'number',
    rules: ['between_price'],
    hideDetails: 'auto',
    min: -9999999999,
    max: 9999999999
  };
  export const TransferUnitPrice = {
    name: 'transfer_unit_price',
    type: 'number',
    rules: ['between_price'],
    hideDetails: 'auto',
    min: -9999999999,
    max: 9999999999
  };
  export const StandardUnitPrice = {
    name: 'standard_unit_price',
    type: 'number',
    rules: ['between_price'],
    hideDetails: 'auto',
    min: -9999999999,
    max: 9999999999
  };
  export const UnitLowerLimit = {
    name: 'unit_lower_limit',
    type: 'number',
    rules: ['between_price'],
    min: -9999999999,
    max: 9999999999,
    hideDetails: 'auto'
  };
  export const UnitUpperLimit = {
    name: 'unit_upper_limit',
    type: 'number',
    rules: ['between_price'],
    min: -9999999999,
    max: 9999999999,
    hideDetails: 'auto'
  };
}
export const MaterialtemplateListDisplayInputFormatItems = MaterialtemplateListDisplayInputFormatItem;

export const MaterialtemplateListDisplayInputFormatItemsPartsList = [
  MaterialtemplateListDisplayInputFormatItems.Quantity,
  MaterialtemplateListDisplayInputFormatItems.QuantityLowerLimit,
  MaterialtemplateListDisplayInputFormatItems.QuantityUpperLimit,
  MaterialtemplateListDisplayInputFormatItems.SalePrice,
  MaterialtemplateListDisplayInputFormatItems.UnitLowerLimit,
  MaterialtemplateListDisplayInputFormatItems.UnitUpperLimit,
];

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace MaterialtemplateCommodityMasterData {
  // 見積表内マスタ参照で表示するカラム設定
  export const Columns = [
    { text: 'サービス種別', value: 'service_type_id', width: '80' },
    { text: '商材', value: 'commodity', width: '100' },
    { text: '商材仕入先', value: 'supplier_id', width: '100' }
  ];
}
export const MaterialtemplateCommodityMasterDatas = MaterialtemplateCommodityMasterData;

export const MaterialtemplateDatailBaseFormat = {
  No: 1,
  copyButton: 0,
  deleteButton: 0,
  selectButtonIndex: 0,
  id: 0,
  delete_flag: 0,
  estimate_id: '',
  item_code: '',
  item: '',
  unit_price: 0,
  quantity: 0,
  reference_purchase_unit_price: 0,
  purchase_unit_price: 0,
  classification_id: '',
  classification: '',
  type_id: '',
  type: '',
  remarks: '',
  // 見積明細トランにない項目(計算などで使用)
  sale_price: 0,
  purchasing_price: 0,
  operating_income: 0,
  profit_rate: '0%',
  input_flag: false
};

//検索時の初期表示Option
export const StatusSelectInitialOption: { text: string; value: string[] } = {
  text: '全ステータス',
  value: []
};
export const DetailNotFoundMessage = '明細情報はありませんでした';

export const filterSelect = [
  { key: 'supplier_id', target: 'supplier_staff_id' },
  { key: 'payment_destination_supplier_id', target: 'payment_information_id' },
  { key: 'item_id', target: 'standard_name', isDetail: true }
];

export const bulkMessage: { [k: string]: string } = {
  noItems: 'アイテムを選択してください',
  notMatch: 'アイテムステータスが一致していません',
  apiSuccess: '処理が完了しました',
  apiError: '以下のアイテムの処理が失敗いたしました'
};

// ActionButtonWithSearchPanelに設定(案件新規登録ボタン)
export const MaterialTemplateRegisterActionButton = [
  {
    action_id: '',
    action_name: '案件新規登録',
    display_id: '案件新規登録',
    display_order: 0,
    crud_type: '',
    next_status_id: '',
    isDisable: false
  }
];

export const MaterialTemplateListDisplayButtonDisabledItems = [
  {
    alwaysDisplayed: false,
    class: 'btn-normal',
    name: 'copyButton',
    text: 'コピー',
    disabled: true
  },
  {
    alwaysDisplayed: false,
    class: 'btn-normal',
    name: 'deleteButton',
    text: '削除',
    disabled: true
  },
  {
    alwaysDisplayed: false,
    class: 'btn-normal',
    name: 'selectButtonIndex',
    text: '検索',
    disabled: true
  },
  {
    alwaysDisplayed: false,
    class: 'btn-normal',
    name: 'remarks',
    text: '備考',
    disabled: false
  },
  {
    'alwaysDisplayed': false,
    'class': 'btn-normal',
    'name': "edit_price_flag",
    'text': "変更可",
    'disabled': true,
    'changeText': "変更不可",
    'fieldId': 'edit_price_flag'
  }, 
  {
    'alwaysDisplayed': false,
    'class': 'btn-normal',
    'name': "edit_material_flag",
    'text': "編集可",
    'disabled': true,
    'changeText': "編集不可",
    'fieldId': 'edit_material_flag'
  },  
];

export const MaterialTemplateListDisplayButtonItems = [
  {
    'alwaysDisplayed': false,
    'class': 'btn-normal',
    'name': "edit_price_flag",
    'text': "変更可",
    'disabled': false,
    'changeText': "変更不可",
    'fieldId': 'edit_price_flag'
  },
  {
    'alwaysDisplayed': false,
    'class': 'btn-normal',
    'name': "edit_material_flag",
    'text': "編集可",
    'disabled': false,
    'changeText': "編集不可",
    'fieldId': 'edit_material_flag'
  }
];

export const toolTipsMessage: { [k: string]: string } = {
  materialTemplate_CreateBasicInfoPlusInfo: 'ダミーツールチップメッセージ'
};

/* eslint-enable @typescript-eslint/camelcase */
